import { LOCATION_CHANGE } from 'connected-react-router';
import { handleActions } from 'redux-actions';

import * as types from './types';

const initialState = {
  data: {},
  error: null,
  isSubmitted: false,
  loading: false,
  protectionPwd: null,
  resetSent: false,
  saving: false,
  token: null,
};

const locationChange = (state, payload) => ({
  ...state,
  data: {
    ...state.data,
  },
  error: null,
});

const forgotPasswordRequest = (state, payload) => ({
  ...state,
  error: null,
  loading: true,
  forgotUsername: payload.data.username,
});
const forgotPasswordRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  resetSent: false,
});
const forgotPasswordRequestSuccess = (state) => ({
  ...state,
  error: null,
  loading: false,
  resetSent: true,
});

const getUserRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const getUserRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const getUserRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data,
  error: null,
  loading: false,
});

const loginRequest = (state) => ({
  ...state,
  data: {
    ...state.data,
  },
  error: null,
  loading: true,
});
const loginRequestFailure = (state, action) => ({
  ...state,
  data: {
    ...state.data,
  },
  error: action.error,
  loading: false,
});
const loginRequestSuccess = (state, payload) => ({
  ...state,
  data: { ...payload.data.user },
  error: null,
  loading: false,
  token: payload.data.token,
  refreshToken: payload.data.refreshToken,
});

const logoutRequest = (state, payload) => initialState;

const protectionPwdRequest = (state, payload) => ({
  ...state,
  error: null,
  loading: true,
  protectionPwd: null,
});
const protectionPwdRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  protectionPwd: null,
});
const protectionPwdRequestSuccess = (state, payload) => ({
  ...state,
  loading: false,
  protectionPwd: payload.data,
});

const registerRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const registerRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const registerRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data,
  error: null,
  loading: false,
  token: null,
});

const registerResetEmailRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const registerResetEmailRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const registerResetEmailRequestSuccess = (state, payload) => ({
  ...state,
  error: null,
  loading: false,
  token: null,
});

const registerEmployeeRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const registerEmployeeRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const registerEmployeeRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data.user,
  error: null,
  loading: false,
  token: payload.data.token,
});

const registerSetSubmitted = (state, payload) => ({
  ...state,
  isSubmitted: payload.data,
});

const resetForgotState = (state) => ({
  ...state,
  resetSent: false,
});

const resetPasswordRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const resetPasswordRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
});
const resetPasswordRequestSuccess = (state, payload) => ({
  ...state,
  error: null,
  loading: false,
});

const sendFallbackMfaRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const sendFallbackMfaRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
});
const sendFallbackMfaRequestSuccess = (state, payload) => ({
  ...state,
  error: null,
  loading: false,
});

const updateUserLastActiveTimesheetRequestFailure = (state, action) => state;

const updateUserLastActiveTimesheetRequestSuccess = (state, payload) => state;

const updateUserRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const updateUserRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const updateUserRequestSuccess = (state, payload) => ({
  ...state,
  data: { ...payload.data },
  error: null,
  saving: false,
});

const validateResetTokenRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const validateResetTokenRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const validateResetTokenRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const verifyUserRequest = (state) => ({
  ...state,
  error: null,
  loading: false,
  saving: true,
});
const verifyUserRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  saving: false,
});
const verifyUserRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data.user,
  error: null,
  loading: false,
  saving: false,
  token: payload.data.token,
});

const updateAccessToken = (state, payload) => ({
  ...state,
  token: payload.data.token,
});

const updatePasswordRequest = (state) => ({
  ...state,
  error: null,
  loading: false,
  saving: true,
});
const updatePasswordRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  saving: false,
});
const updatePasswordRequestSuccess = (state, payload) => ({
  ...state,
  error: null,
  loading: false,
  saving: false,
});

export default handleActions(
  {
    [LOCATION_CHANGE]: locationChange,
    [types.FORGOT_PASSWORD_REQUEST]: forgotPasswordRequest,
    [types.FORGOT_PASSWORD_REQUEST_FAILURE]: forgotPasswordRequestFailure,
    [types.FORGOT_PASSWORD_REQUEST_SUCCESS]: forgotPasswordRequestSuccess,
    [types.GET_USER_REQUEST]: getUserRequest,
    [types.GET_USER_REQUEST_FAILURE]: getUserRequestFailure,
    [types.GET_USER_REQUEST_SUCCESS]: getUserRequestSuccess,
    [types.LOGIN_REQUEST]: loginRequest,
    [types.LOGIN_REQUEST_FAILURE]: loginRequestFailure,
    [types.LOGIN_REQUEST_SUCCESS]: loginRequestSuccess,
    [types.LOGOUT_REQUEST]: logoutRequest,
    [types.PROTECTION_PWD_REQUEST]: protectionPwdRequest,
    [types.PROTECTION_PWD_REQUEST_FAILURE]: protectionPwdRequestFailure,
    [types.PROTECTION_PWD_REQUEST_SUCCESS]: protectionPwdRequestSuccess,
    [types.REGISTER_REQUEST]: registerRequest,
    [types.REGISTER_REQUEST_FAILURE]: registerRequestFailure,
    [types.REGISTER_REQUEST_SUCCESS]: registerRequestSuccess,
    [types.REGISTER_RESEND_EMAIL_REQUEST]: registerResetEmailRequest,
    [types.REGISTER_RESEND_EMAIL_REQUEST_FAILURE]: registerResetEmailRequestFailure,
    [types.REGISTER_RESEND_EMAIL_REQUEST_SUCCESS]: registerResetEmailRequestSuccess,
    [types.REGISTER_EMPLOYEE_REQUEST]: registerEmployeeRequest,
    [types.REGISTER_EMPLOYEE_REQUEST_FAILURE]: registerEmployeeRequestFailure,
    [types.REGISTER_EMPLOYEE_REQUEST_SUCCESS]: registerEmployeeRequestSuccess,
    [types.REGISTER_SET_SUBMITTED]: registerSetSubmitted,
    [types.RESET_FORGOT_STATE]: resetForgotState,
    [types.RESET_PASSWORD_REQUEST]: resetPasswordRequest,
    [types.RESET_PASSWORD_REQUEST_FAILURE]: resetPasswordRequestFailure,
    [types.RESET_PASSWORD_REQUEST_SUCCESS]: resetPasswordRequestSuccess,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST]: sendFallbackMfaRequest,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE]: sendFallbackMfaRequestFailure,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS]: sendFallbackMfaRequestSuccess,
    [types.UPDATE_ACCESS_TOKEN]: updateAccessToken,
    [types.UPDATE_PASSWORD_REQUEST]: updatePasswordRequest,
    [types.UPDATE_PASSWORD_REQUEST_FAILURE]: updatePasswordRequestFailure,
    [types.UPDATE_PASSWORD_REQUEST_SUCCESS]: updatePasswordRequestSuccess,
    [types.UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE]: updateUserLastActiveTimesheetRequestFailure,
    [types.UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS]: updateUserLastActiveTimesheetRequestSuccess,
    [types.UPDATE_USER_REQUEST]: updateUserRequest,
    [types.UPDATE_USER_REQUEST_FAILURE]: updateUserRequestFailure,
    [types.UPDATE_USER_REQUEST_SUCCESS]: updateUserRequestSuccess,
    [types.VERIFY_USER_REQUEST]: verifyUserRequest,
    [types.VERIFY_USER_REQUEST_FAILURE]: verifyUserRequestFailure,
    [types.VERIFY_USER_REQUEST_SUCCESS]: verifyUserRequestSuccess,
    [types.VALIDATE_RESET_TOKEN_REQUEST]: validateResetTokenRequest,
    [types.VALIDATE_RESET_TOKEN_REQUEST_FAILURE]: validateResetTokenRequestFailure,
    [types.VALIDATE_RESET_TOKEN_REQUEST_SUCCESS]: validateResetTokenRequestSuccess,
  },
  initialState
);
